export default __webpack_public_path__ + "static/media/thue_xe_tu_lai_gia_re_hcm.ffd1319e.svg";